<template>
    <div @click="abrirModal">
        <b-card no-body :class="`bg-gradient-${bgVariante}`">
            <img src="@/assets/images/lines.svg" class="dashboard card-img-absolute" alt="circle-image">
            <slot name="cabecalho">
                <h6 class="text-center text-white mt-4 mb-3 text-uppercase">
                    <slot name="titulo">
                        {{titulo}}
                    </slot>
                </h6>
            </slot>
            <slot name="valor">
                <h3 class="text-center font-size-20 mb-4 text-white">{{monetario ? formatarValor(valor) : valor}}</h3>
            </slot>
        </b-card>
        <b-modal size="xl" :id="`bv-modal-${id}`" :title="tituloModal">
            <div class="table-responsive">
                <b-table head-variant="dark" :fields="colunas" :items="dados"></b-table>
            </div>
        </b-modal>
    </div>
</template>
<script>
import helpers from '@/common/utils/helpers'

export default {
    name: 'CardDashboard',
    props : {
        bgVariante : {
            type : String,
            default : 'primary'
        },
        icone : {
            type : String,
            default : 'fa-clipboard-list'
        },
        titulo : {
            type : String,
            default : 'Título'
        },
        valor : {
            default :null
        },
        monetario : {
            type : Boolean,
            default : false
        },
        id : {
            default : null
        },
        tituloModal : {
            type : String,
            default : ''
        },
        colunas : {
            default : () => []
        },
        dados : {
            default : () => []
        },
    },
    methods : {
        formatarValor : function(valor){
            if(valor == null) return 'R$ -';
            return helpers.formatarValor(valor);
        },
        abrirModal : function(){
            if(this.id)
                this.$bvModal.show(`bv-modal-${this.id}`);
        }
    }
}
</script>
<style>
    .dashboard .card-img-absolute {
        position: absolute !important;
        top: 0 !important;
        right: 0 !important;
        height: 100% !important;
    }
</style>